<script setup>
  import { OptionsForm } from '@haskoning/vue-component-library'
  import ProjectForm from '../form/ProjectForm.vue'

  const props = defineProps({
    name: { type: String, required: false },
    store: { type: Object, required: true }
  })

  const { createUpdateDialog, writeLoading, currentItem } = storeToRefs(props.store)
  const emit = defineEmits(['save'])
  const createOrUpdate = computed(() => {
    return currentItem.value['id']
      ? 'Update'
      : currentItem.value['duplicated_id']
      ? 'Duplicate'
      : 'Create'
  })

  async function createOrUpdateAction() {
    if (props.overrideCreateOrUpdate) {
      emit('save')
      props.store.toggleCreateUpdateDialog(false)
    } else {
      await props.store.postOrUpdate()
      props.store.toggleCreateUpdateDialog(false)
    }
  }
</script>
<template>
  <v-dialog
    :model-value="createUpdateDialog"
    @click:outside.stop="store.toggleCreateUpdateDialog()"
    max-width="400"
  >
    <v-card class="pa-3">
      <v-card-title>{{ createOrUpdate }} {{ name }}</v-card-title>
      <v-card-text class="pl-4">
        <ProjectForm :store="store" state-name="currentItem" v-model="formValid">
          <template #prepend>
            <slot></slot>
          </template>
        </ProjectForm>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary text-none" variant="text" @click="store.toggleCreateUpdateDialog()">
          Cancel
        </v-btn>
        <v-btn
          :loading="writeLoading"
          color="primary text-none"
          variant="text"
          @click="createOrUpdateAction"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
